export interface UserSchedule {
	id: string | null
	userId: string | null
	startScheduleId: string | null
	startStatusId: string | null
	endScheduleId: string | null
	endStatusId: string | null
	note: string | null
	permanentStartDate: Date | null
}

export interface UserStatusScheduleView extends UserSchedule {
	timeZone: string | null
	startDate: string | null
	endDate: string | null
	inProgress?: boolean
	dateRange?: {
		start: Date | null
		end: Date | null
	}
	scheduleStatus?: UserScheduleStatus | null
}

export interface UserStatusScheduleRun {
	id: string,
	userId: string | null,
	startDate: string | null,
	endDate: string | null,
	status: string | null
}

export enum UserScheduleStatus {
	Upcoming = 0,
	Active = 1
}
